module.exports = __webpack_public_path__ + "static/media/gardony-felveteli-epulet-es-biztber-kialakitas-alvallalkozasban.f9b607fe.jpg";